export const ACCOUNT_STORAGE_KEYS = {
  accessToken: "access_token",
  refreshToken: "refresh_token",
};
